import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBColumnModel} from "FormBuilder/Core/FBColumn.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {CalculatorBase} from "FormBuilder/Core/Calulators/CalculatorBase";
import {CalculatorFactory} from "FormBuilder/Core/Calulators/CalculatorFactory";

export abstract class FBFieldWithPriceBaseModel<Op extends FBFieldWithPriceBaseOptions=FBFieldWithPriceBaseOptions,P extends FBColumnModel=FBColumnModel> extends FBFieldBaseModel<Op,P>{
    calculator:CalculatorBase;
    Immediate:boolean;
    Quantity:any;

    constructor(Options: Op, Parent: P) {
        super(Options, Parent);
        this.Immediate=true;

    }

    protected InternalSerialize(obj: any) {

        obj.PriceType=this.Options.PriceType;
        obj.Price=this.calculator.GetPrice();
        obj.SalePrice=this.calculator.GetSalePrice();
        obj.Quantity=this.calculator.GetQuantity();
        obj.UnitPrice=this.calculator.GetUnitPrice();
    }


    GetIsUsed(): boolean {
        if(!super.GetIsUsed())
            return false;

        if(this.Options.ShowQuantitySelector&& this.Quantity==0)
            return false;

        return true;
    }


    InitializeConditions() {
        if(this.FormBuilder!=null)
            this.InitializePriceCalculator();
        super.InitializeConditions();
    }

    public GetPrice(){
        if(this.Options.PriceType==PriceTypeEnum.none)
        {
            let price=parseFloat(this.GetText());
            if(isNaN(price))
                return 0;

            return price;
        }
        return this.calculator.GetPrice();
    }

    protected ExecuteInitialCalculation(){

    }


    public GetSalePrice(){
        return this.Options.SalePrice==null?"":this.Options.SalePrice.toString().trim();
    }

    public GetRegularPrice(){
        return this.Options.Price==null?"":this.Options.Price.toString().trim();
    }

    protected InitializePriceCalculator() {
        this.calculator=CalculatorFactory.GetCalculator(this.Options.PriceType);
        this.calculator.Initialize(this);
    }


    FireValueChanged() {
        if (this.calculator != null)
            this.calculator.ExecuteAndUpdate(this.calculator.GetForceUpdateWhenFieldChange(),true);
        super.FireValueChanged();

    }

    public SetPrice(price:number){
        this.calculator.UpdatePrice(price,'',this.calculator.GetQuantityInput());
    }

    public abstract GetValue();
}